import script from "./9.ExperienceBurningItchingSensation.vue?vue&type=script&setup=true&lang=ts"
export * from "./9.ExperienceBurningItchingSensation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__